
import React from 'react';
import SEO from '../components/SEO';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEO
        title={`Privacy Policy — Law and Code Africa`}
        description={`How Law and Code Africa collects, uses, and safeguards your information when you visit our website and use our services.`}
        path="/privacy"
      />
      {/* Hero */}
      <section className="bg-primary text-white py-20">
        <div className="max-w-4xl mx-auto px-4 md:px-8">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Privacy Policy</h1>
          <p className="text-blue-200 text-lg">Last updated: February 2026</p>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-4 md:px-8 py-16 space-y-10">
        <div>
          <h2 className="text-2xl font-bold text-primary mb-4">1. Introduction</h2>
          <p className="text-muted-foreground leading-relaxed">
            Law and Code Africa ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website and use our services.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-primary mb-4">2. Information We Collect</h2>
          <p className="text-muted-foreground leading-relaxed mb-3">We may collect the following types of information:</p>
          <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-4">
            <li><strong>Personal Information:</strong> Name, email address, phone number, and other contact details you voluntarily provide through our contact forms or mentorship applications.</li>
            <li><strong>Usage Data:</strong> Information about how you interact with our website, including pages visited, time spent, and browser type.</li>
            <li><strong>Cookies:</strong> Small data files stored on your device to enhance your browsing experience.</li>
          </ul>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-primary mb-4">3. How We Use Your Information</h2>
          <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-4">
            <li>To provide and maintain our services</li>
            <li>To respond to your inquiries and communications</li>
            <li>To process mentorship applications</li>
            <li>To improve our website and user experience</li>
            <li>To comply with legal obligations</li>
          </ul>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-primary mb-4">4. Information Sharing</h2>
          <p className="text-muted-foreground leading-relaxed">
            We do not sell, trade, or rent your personal information to third parties. We may share information only when required by law, to protect our rights, or with your explicit consent.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-primary mb-4">5. Data Security</h2>
          <p className="text-muted-foreground leading-relaxed">
            We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-primary mb-4">6. Your Rights</h2>
          <p className="text-muted-foreground leading-relaxed mb-3">You have the right to:</p>
          <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-4">
            <li>Access the personal data we hold about you</li>
            <li>Request correction of inaccurate data</li>
            <li>Request deletion of your personal data</li>
            <li>Withdraw consent at any time</li>
          </ul>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-primary mb-4">7. Contact Us</h2>
          <p className="text-muted-foreground leading-relaxed">
            If you have any questions about this Privacy Policy, please contact us at{' '}
            <a href="mailto:lawandcodeafrica@gmail.com" className="text-primary hover:underline font-medium">
              lawandcodeafrica@gmail.com
            </a>.
          </p>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
